import type { SchemaBuilderFormListRowProps } from "./schema-builder-form-list-row.type";

import { CloseOutlined } from "@ant-design/icons";
import { Button, Form } from "antd";
import { useTranslation } from "react-i18next";

export const SchemaBuilderFormListRow = ({
  index,
  title,
  titleRequired,
  deleteText,
  deleteDisabled,
  onDeleteClick,
  content,
  actionsBefore,
  actionsAfter,
  extra,
}: SchemaBuilderFormListRowProps) => {
  const { t } = useTranslation();

  return (
    <div className="schema-builder-form-list-row">
      {title && (
        <Form.Item
          className="schema-builder-form-list-row-title"
          label={t(title, { index: index + 1 })}
          required={titleRequired}
        />
      )}
      <div className="schema-builder-form-list-row-content">
        <div className="schema-builder-form-list-row-field">{content}</div>
        <div className="schema-builder-form-list-row-actions">
          {actionsBefore}
          <Button
            danger
            type="text"
            icon={<CloseOutlined />}
            onClick={onDeleteClick}
            disabled={deleteDisabled}
            aria-label={deleteText}
          />
          {actionsAfter}
        </div>
      </div>
      {extra}
    </div>
  );
};
